import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import authService from '../services/authService';

// Global redirect guard to prevent navigation flood when multiple ProtectedRoutes render
let redirectGuard = { inFlight: false };

const ProtectedRoute = ({ children, requiredRole = null }) => {
    const { isAuthenticated, isLoading } = useAuth();
    const hasPermission = requiredRole ? authService.hasRole(requiredRole) : true;

    useEffect(() => {
        if (isAuthenticated) {
            redirectGuard.inFlight = false;
        }
    }, [isAuthenticated]);

    // Show loading spinner while checking authentication
    if (isLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    // Redirect to login if not authenticated
    if (!isAuthenticated) {
        if (!redirectGuard.inFlight) {
            redirectGuard.inFlight = true;
            return <Navigate to="/pages/login" replace />;
        }
        // Fallback UI if a redirect is already in-flight (prevents throttling loop)
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                <div className="text-center text-muted">Redirecting to login…</div>
            </div>
        );
    }

    // Show access denied if user doesn't have required role
    if (!hasPermission) {
        return (
            <div className="container mt-5">
                <div className="row justify-content-center">
                    <div className="col-md-6">
                        <div className="card">
                            <div className="card-body text-center">
                                <h3 className="text-danger">Access Denied</h3>
                                <p className="text-muted">
                                    You don't have permission to access this page.
                                    {requiredRole && (
                                        <><br />Required role: <strong>{Array.isArray(requiredRole) ? requiredRole.join(', ') : requiredRole}</strong></>
                                    )}
                                </p>
                                <button 
                                    className="btn btn-primary"
                                    onClick={() => window.history.back()}
                                >
                                    Go Back
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // Render protected content
    return children;
};

export default ProtectedRoute;